import { render, staticRenderFns } from "./taxledgers.vue?vue&type=template&id=7622994a"
import script from "./taxledgers.vue?vue&type=script&lang=js"
export * from "./taxledgers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports